
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <table>
    <caption>Zubereitung</caption>
    <tbody>
        <tr><td>
Zucchini waschen, putzen und grob raspeln, Frühlingszwiebel waschen, putzen und in sehr dünne Ringe schneiden. Zucchiniraspel und Frühlingszwiebel mit Haselnüssen, Vollkornmehl, geriebenem Käse und Eier verrühren. Mit Salz und Pfeffer würzen.
            <p>{`In einer großen Pfanne Olivenöl erhitzen. Jeweils 1 gehäuften EL Zucchinimasse hineinsetzen und flach drücken. Von jeder Seite bei mittlerer Hitze in ca. 4 Min. goldbraun braten. Puffer auf Küchenpapier abtropfen lassen.`}</p>
            <b>Für das Tsatsiki</b><br />
Salatgurke schälen, längs halbieren und entkernen. Die Gurke grob raspeln. Knoblauch pressen, Gurkenraspel mit Knoblauch, Olivenöl und Joghurt mischen. Zucchinipuffer mit Tsatsiki und grünen Oliven servieren.
          </td></tr>
      </tbody>
    </table>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;